import { useAuthRoutes } from "shared/auth/useAuthRoutes";
import { useUser } from "shared/auth/user/context";
import { useFetchJson } from "shared/fetch/useFetchJson";
import Loading from "shared/loading";
import { useRunOnMount } from "shared/useRunOnMount/useRunOnMount";

export default function Logout() {
  const { run } = useFetchJson();
  const { goToLoginPage } = useAuthRoutes();
  const { clearUser } = useUser();
  useRunOnMount(() => {
    run("/auth/api/logout", { method: "post" }).then(() => {
      clearUser();
      goToLoginPage();
    });
  });
  return (
    <>
      <Loading className="mt-3" />
    </>
  );
}
